import { render, staticRenderFns } from "./OverseasBanksForm.vue?vue&type=template&id=458f1b6d&scoped=true&"
import script from "./OverseasBanksForm.vue?vue&type=script&lang=js&"
export * from "./OverseasBanksForm.vue?vue&type=script&lang=js&"
import style0 from "./OverseasBanksForm.vue?vue&type=style&index=0&id=458f1b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f1b6d",
  null
  
)

export default component.exports